import { useCallback, useState } from 'react'

export const useListControls = (initialItemsPerPage = 10) => {
    const [page, setPage] = useState(0)
    const [search, setSearch] = useState('')
    const [sort, setSort] = useState<'ascending' | 'descending'>('ascending')
    const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage)

    const handlePaginationChange = useCallback((_: any, value: number) => {
        setPage(value)
    }, [])

    const handleSearchChange = useCallback((value: string) => {
        setSearch(value)
        setPage(0)
    }, [])

    const handleItemsPerPageChange = useCallback((e: any) => {
        const value = Number(e.target.value)
        setItemsPerPage(value)
        setPage(0)
    }, [])

    const handleSort = useCallback(() => {
        setSort((prev) => (prev === 'ascending' ? 'descending' : 'ascending'))
        setPage(0)
    }, [])

    return {
        page,
        search,
        sort,
        itemsPerPage,
        handlePaginationChange,
        handleSearchChange,
        handleItemsPerPageChange,
        handleSort,
    }
}
